import { memo } from 'react'
import type { BouquetSectionModelProps } from '@/components/home/components/bouquet-section/bouquet-section.model'
import { useBouquetSectionModel } from '@/components/home/components/bouquet-section/bouquet-section.model'
import { BouquetSectionView } from '@/components/home/components/bouquet-section/bouquet-section.view'

export const BouquetSectionViewModel = memo(function BouquetSectionViewModel(
  props: BouquetSectionModelProps,
) {
  const model = useBouquetSectionModel(props)
  return <BouquetSectionView {...model} />
})
